import React from 'react';
import isMobile from '$/utils/isMobile';
import useRunOnce from '$/hooks/useRunOnce';

interface HeaderContextValue {
  headerHeight: number; // height is different when having a sticky banner (toast)
  bannerHeight: number; // difference in header height when header have banner
  announcementHeight: number; // difference in header height when header have banner
  totalHeight: number;
  hasBanner: boolean;
  setHasBanner: (value: boolean) => void;
}

const HeaderContext = React.createContext<HeaderContextValue>({} as HeaderContextValue);

export const HeaderContextProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const [headerHeight, setHeaderHeight] = React.useState(isMobile ? 73 : 100);
  const [bannerHeight, setBannerHeight] = React.useState(0);
  const [announcementHeight, setAnnouncementHeight] = React.useState(0);

  useRunOnce(() => {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function () {
        setAnnouncementHeight(parseInt(document.body.style.marginTop) || 0);
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
    });

    setAnnouncementHeight(
      document.body.style.marginTop ? parseInt(document.body.style.marginTop) : 0
    );

    window.productFruits?.api?.announcements.listen('banner-spacing', (spacingInfo: number) => {
      // You will get the spacingInfo which holds the marginTop property
      // Move the fixed element(s) by marginTop
      setAnnouncementHeight(spacingInfo);
    });
  });

  const setHasBanner = (hasBanner: boolean): void => {
    const heightDesktop = hasBanner ? 140 : 100;
    const heightMobile = hasBanner ? 140 : 73;
    setHeaderHeight(isMobile ? heightMobile : heightDesktop);
    setBannerHeight(hasBanner ? (isMobile ? 60 : 40) : 0);
  };
  const hasBanner = bannerHeight + announcementHeight !== 0;
  const value = {
    hasBanner,
    setHasBanner,
    bannerHeight: bannerHeight,
    headerHeight: headerHeight,
    announcementHeight: announcementHeight,
    totalHeight: announcementHeight + headerHeight,
  };
  return <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>;
};

export const useHeaderContext = (): HeaderContextValue => React.useContext(HeaderContext);
